<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container">
                    <div class="page-links">
                        <router-link to="/trips/tanzania" class="page-links__item">Tanzania Day Trips</router-link>
                        <router-link to="/trips/safari" class="page-links__item">Safari Activities</router-link>
                        <router-link to="/trips/island" class="page-links__item is-active">Island Activities</router-link>
                    </div>
					<div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
            <section class="np-detail" v-if="isLoad">
              <div class="page-title">
                <h2>Island Activities</h2>
              </div>
                <div class="section-title">
                    <h3>{{isEdit ? 'Edit Island Activity' : 'Add Island Activity'}}</h3><a @click="$router.back()" href="javascript:void(0)" class="btn btn--back">
                    <div class="btn--back__icon">
                        <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                        </svg>
                    </div><span>Back</span></a>
                </div>
				<div :class="['form-control-group form-control-group__island', {'is-error' : errors.island}]"><span class="form-control-label">Island</span>
					<div :class="['select-wrapper', { 'is-active' : selects.island }]" @click="changeSelects('island');errors.island = false" >
					<div class="select-trigger"><span class="select-trigger__name">Zanzibar</span><span
						class="select-trigger__icon">
						<svg width="1em" height="1em" class="icon icon-chevron ">
							<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
						</svg></span></div>
					<div class="select-body">
						<div class="select-inner js-scrollbar">
						<div class="select-option"><span class="select-option__name">Zanzibar</span></div>
						<div class="select-option is-selected"><span class="select-option__name">Zanzibar2</span></div>
						<div class="select-option"><span class="select-option__name">Zanzibar3</span></div>
						<div class="select-option"><span class="select-option__name">Zanzibar4</span></div>
						</div>
					</div>
					</div>
				</div>
              <form action="javascript:void(0)" class="np-detail-form">
                <div class="np-detail-section">
                  <div class="np-detail-section__title"><span>1. Info</span></div>
                  <div
                    v-for="item in info"
                    :key="item.title"
                    :class="['np-detail-collapse', 'js-collapse', { 'is-collapsed' : item.collapse }]">
                    <div class="np-detail-collapse__title">
                      <div class="np-detail-collapse__lang">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
                          </svg>
                        </div><span class="np-detail-collapse__lang__text">{{item.title}}</span>
                      </div>
                      <button
                        type="button"
                        data-opened="Hide" data-closed="Show"
                        :class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': item.collapse }]"
                        @click="item.collapse = !item.collapse"
                        >
                        <div class="btn--collapse__icon">
                          <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                          </svg>
                        </div>
                      </button>
                    </div>
                    <div class="np-detail-collapse__inner js-collapse-inner">
                      <div class="np-detail-collapse__body">
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Name</span>
                              <div class="form-control-wrap">
                                <input type="text" placeholder="Activity name" v-model="item.name" @input="isEditFlag = true"  @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" v-model="item.desc" @input="isEditFlag = true" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" v-model="item.note" @input="isEditFlag = true" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__filters">
                    <div class="np-detail-section__filters__inner">
						<div :class="['form-control-group', {'is-error' : errors.territory}]"><span class="form-control-label">Territory</span>
                            <div :class="['select-wrapper', { 'is-active' : selects.ter }]" @click="changeSelects('ter');errors.territory = false">
                                <div class="select-trigger"><span class="select-trigger__name">{{territory.find(item => item.active) ? territory.find(item => item.active).title : ''}}</span><span
                                    class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                    <div
                                        v-for="item in territory"
                                        :key="item.id"
                                        :class="['select-option', {'is-selected' : item.id === territory.find(item => item.active).id}]"
                                        @click="territory = territory.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false});isEditFlag = true"
                                        ><span class="select-option__name">{{item.title}}</span></div>
                                </div>
                                </div>
                            </div>
                      </div>
                      <div class="form-control-group form-control-group--lg"><span class="form-control-label">Duration (in minutes)</span>
                        <div :class="['form-control-wrap', {'is-error' : errors.duration}]">
                          <input type="number" placeholder="Duration" v-model="duration" @focus="errors.duration = false" class="form-control"/>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-photo-group form-control-photo-group--squared">
						<input type="file" :id="'photo_load'" class="input-hidden" />
						<label  class="form-control-photo" v-if="!photo" @click="$emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
						<div class="form-control-photo" v-if="photo"><span class="form-control-photo__box h-object-fit"><img
								:src="`${API}/documents/share/images/${photo}?size=LARGE`" alt="photo"></span>
							<button type="button" class="btn btn--remove" @click="photo = null">
								<svg width="1em" height="1em" class="icon icon-close ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
								</svg>
							</button>
							</div>
						<div class="form-control-photo-content">
							<div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
							<div class="form-control-photo-content__line">
								<label class="btn btn--rounded btn-photo-load" @click="$emit('changeImage', 'itinerary')">{{photo ? 'Change photo' : 'Add Photo'}}</label>
							</div>
							<div class="form-control-photo-content__line" v-if="!photo"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
						</div>
					</div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__title np-detail-section__title--no-border"><span>2. Age settings</span></div>
                  <div class="age-settings">
                    <div class="age-box">
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>Min Age</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.min" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-child ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Child</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.child" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-teenager ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Teenager</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.teenFrom" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.teenTo" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-adult ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Adult</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.adult" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <IslandPrices @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @deleteModalHandler="data => $emit('deleteModalHandler', data)" :island="island" :user="user" :save="save" @closeSelects="changeSelects"/>
                <div class="np-detail-form__submit np-detail-form__submit--no-border">
                    <button type="button" class="btn btn--silver" @click="deleteIslandHandler()" v-if="isEdit"> <span>Delete</span></button>
                    <button type="button" class="btn btn--green btn--shadowed" @click="isEdit ? updateIslandHandler() : createIslandHandler()"><span>{{isEdit ? 'Save' : 'Add'}}</span></button>
                </div>
              </form>
            </section>
          </div>
        </div>
        </main>
    </div>
</template>

<script>

    import {
        API,
        createIsland,
        updateIsland,
        getIsland,
        deleteIsland,
		getTerritoriesAll
    } from '@/utilites/api'


    import CKEditor from '@ckeditor/ckeditor5-vue2'
    import ClassicEditor from '@/utilites/ckeditor'

    import SeasonBox from '@/components/SeasonBox'
    import IslandPrices from '@/components/IslandPrices'

    export default {
        components: { editor: CKEditor.component, SeasonBox, IslandPrices },
        props: ['user', 'uploadedFile'],
        data(){
            return {
				API: API,
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Write description'
                },
                editorConfig2: {
                    placeholder: 'Write notes'
                },
                info: [
                    {
                        title: 'English',
                        icon: 'gb',
                        collapse: true,
                        name: '',
                        desc: '',
                        note: ''
                    },
                    {
                        title: 'Russian',
                        icon: 'rus',
                        collapse: false,
                        name: '',
                        desc: '',
                        note: ''
                    },
                ],
                selects: {
                    seasons: false,
					ter: false,
					island: false,
                },
				photo: null,
                age: {
                    min: '',
                    child: '',
                    teenFrom : '',
                    teenTo: '',
                    adult: ''
                },
				territory: [],
                duration: '',
				isEdit: false,
				island: null,
                save: 0,
				isLoad: false,
				errors: {
					territory: false,
					duration: false,
					island: false
				},
				isEditFlag: false
            }
        },
		beforeRouteLeave(to, from, next){
			if(this.isEditFlag){
				this.$emit('notLeaveHandler')
			}
			next()
		},
        methods: {
			changeSelects(target){
				this.selects = {
                    seasons: false,
					ter: false,
					[target] : !this.selects[target]
				}
			},
			checkError(){
				let error = false
				if(+this.duration <= 0 || !this.territory.find(item => item.active)){
					error = true
					this.errors = {
						territory: !this.territory.find(item => item.active),
						duration: +this.duration <= 0,
						island: false
					}
				}
				document.querySelectorAll('.form-control-name').forEach(elem => {
					if(elem.value.trim().length <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				document.querySelectorAll('.form-control-age').forEach(elem => {
					if(elem.value.trim().length < 0 || +elem.value <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				return error
			},
            createIslandHandler(){
				if(!this.checkError()){
					createIsland(this.user.access_token, {
						territoryId: this.territory.find(item => item.active).id,
						"photo": this.photo,
						"info": {
							"EN": {
								"name": this.info[0].name,
								"description": this.info[0].desc,
								"additionalNotes": this.info[0].note
							},
							"RU": {
								"name": this.info[1].name,
								"description": this.info[1].desc,
								"additionalNotes": this.info[1].note
							},
						},
						duration: this.duration,
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
					.then(res => {
						this.save += 1
						this.island = res
						this.isEdit = res.id
						this.$emit('confirmed')
						this.isEditFlag = false
					})
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
			updateIslandHandler(){
				if(!this.checkError()){
					updateIsland(this.user.access_token, {
						territoryId: this.territory.find(item => item.active).id,
						id: this.island.id,
						"photo": this.photo,
						"info": {
							"EN": {
								"name": this.info[0].name,
								"description": this.info[0].desc,
								"additionalNotes": this.info[0].note
							},
							"RU": {
								"name": this.info[1].name,
								"description": this.info[1].desc,
								"additionalNotes": this.info[1].note
							},
						},
						duration: this.duration,
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
					.then(() => {
						this.$emit('confirmed')
						this.isEditFlag = false
					})
					this.save += 1
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
            deleteIslandHandler(){
				deleteIsland(this.user.access_token, this.island.id)
				.then(res => {
					this.$router.back()
				})
			}
        },
        mounted(){
            document.title = 'Day Trips & Activities / Island Activities'
            this.isEdit = this.$route.params.id
            if(this.isEdit){
				getIsland(this.user.access_token, this.isEdit)
				.then(res => {
					this.island = res
					this.isLoad = true
					this.info = [
						{
							title: 'English',
							icon: 'gb',
							collapse: false,
							name: res.info.EN.name,
							desc: res.info.EN.description,
							note: res.info.EN.additionalNotes
						},
						{
							title: 'Russian',
							icon: 'rus',
							collapse: false,
							name: res.info.RU.name,
							desc: res.info.RU.description,
							note: res.info.RU.additionalNotes
						},
					]
					this.photo = res.photo
                    this.duration = res.duration
					this.age = {
						min: res.ageSettings.minAge,
						child: res.ageSettings.child.to,
						teenFrom : res.ageSettings.teenager.from,
						teenTo: res.ageSettings.teenager.to,
						adult: res.ageSettings.adult.from
					}
				})
			} else {
				this.isLoad = true
			}
			getTerritoriesAll(this.user.access_token)
			.then(res => {
				this.territory = res.map((item, index) => index === 0 ? {...item, active: true} :({...item, active: false}))
			})
			window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        seasons: false,
						ter: false,
						island: false
                    }
                }
            })
        },
		watch: {
			island(){
				getTerritoriesAll(this.user.access_token)
				.then(res => {
					this.territory = res.map((item, index) => this.island.territoryId === item.id ? {...item, active: true} :({...item, active: false}))
				})
			},
			uploadedFile(){
				if(this.uploadedFile){
					this.photo = this.uploadedFile
				}
			}
		}
    }
</script>
